import { type z } from 'zod'

import { schemas } from '~interface/zod-schema'

export type Account = z.infer<typeof schemas.GetAccountViewResponseData>

export type User = z.infer<typeof schemas.GetUserViewResponseData>

export type PasswordPolicy = z.infer<typeof schemas.GetPasswordPolicyViewResponseData>

export type ChangePasswordRequestData = z.infer<typeof schemas.ChangePasswordViewRequestData>

export type SetNotifyRequestData = z.infer<typeof schemas.SetNotifyViewRequestData>

export const SkinEnum = schemas.SkinEnum
export type SkinEnumType = z.infer<typeof schemas.SkinEnum>

export type UserIds = z.infer<typeof schemas.UserIds>
